import React from "react";
import bodyHelperTypes from "../utils/BodyHelperTypes";
import UnorderedList from "../layouts/bodyLayouts/helpers/UnorderedList";
import Links from "../components/Links";



const LittleEyeParticipant_Content = [

    {
        format: bodyHelperTypes.paragraphs,
        order: 10,
        content: [
            <>
                <b>Helping You Stay Independent and Reach Your Goals</b><br />
                The <b>1915(i) RISE Initiative</b> provides extra support to adults with serious mental illness (SMI) who want to live independently, return to work or school, find housing, or reduce hospital visits. 1915(i) RISE services are <b>free</b> for eligible participants and are funded by <b>Kentucky Medicaid.</b>
            </>,
            <></>,
            <>
                <b>What Can 1915(i) RISE Help Me With?</b><br />
                Depending on your needs, 1915(i) RISE can help you:
                <ul>
                    <li>Manage medications.</li>
                    <li>Find and keep housing.</li>
                    <li>Get a job or go back to school.</li>
                    <li>Build daily living skills (cooking, cleaning, budgeting, social skills, etc.).</li>
                    <li>Take a break if you’re a caregiver.</li>
                    <li>Get rides to social activities.</li>
                </ul>
            </>,
            <>
                <b>What Services Are Offered?</b><br />
                Here are the 10 services available through 1915(i) RISE:<br /><br />


                <b>1. Assistive Technology</b><br />
                Tools like reminders, pillboxes, and electronic supports to help you stay independent.<br /><br />

                <b>2. Case Management</b><br />
                Help coordinating your care, setting goals, and getting referrals.<br /><br />

                <b>3.	Housing and Tenancy Supports</b><br />
                Support finding and keeping housing, dealing with landlords, and financial management.<br /><br />

                <b>4.	In-Home Independent Living Supports</b><br />
                Help with daily living like cooking, hygiene, and routines.<br /><br />

                <b>5.	Medication Management</b><br />
                Help with understanding, taking, and tracking medications.<br /><br />

                <b>6.	Planned Respite for Caregivers</b><br />
                Breaks for caregivers while ensuring you still get support.<br /><br />

                <b>7.	Supervised Residential Care</b><br />
                Structured housing with staff on site if you need more support.<br /><br />

                <b>8.	Supported Education</b><br />
                Support enrolling in General Educational Development (GED), college, or training programs.<br /><br />

                <b>9.	Supported Employment</b><br />
                Coaching and job placement based on your skills and interests.<br /><br />

                <b>10.	Non-Medical Transportation</b><br />
                Help getting to services, community activities, and appointments.<br /><br />


            </>,
            <>
                You and your case manager will decide together which services are right for you.
            </>,
            <>
                <b>Who Can Get 1915(i) RISE Services?</b><br />
                To be eligible, you must:<br />
                <ul>
                    <li>Be 18 or older</li>
                    <li>Have Kentucky Medicaid.</li>
                    <li>Have a diagnosis of SMI</li>
                    <li>Need help with daily living, housing, employment, or social support</li>
                    <li>Be at risk of hospitalization, homelessness, or institutionalization.</li>

                </ul>
                See <a href="https://apps.legislature.ky.gov/law/kar/titles/907/016/010/">907 KAR 16:010</a> for further eligibility details.
            </>,
            <>
                <b>What Is a Person-Centered Service Plan (PCSP)?</b><br />
                Your <b>PCSP</b> is the roadmap to your recovery. It:
                <ul>
                    <li>Lists your strengths, preferences, and goals.</li>
                    <li>Identifies which 1915(i) RISE services you want.</li>
                    <li>Names your providers and support team.</li>
                    <li>Can be updated as your needs or goals change.</li>
                </ul>

                You are always in control of your plan.
            </>,
            <>
                <b>What If I Already Receive Services?</b><br />
                The 1915(i) RISE Initiative is designed to add to your current supports — not replace them. Your case manager will help you:
                <ul>
                    <li>Avoid duplication of services.</li>
                    <li>Keep the providers you trust.</li>
                    <li>Coordinate with other programs (e.g., 1915[c] Medicaid Waivers, Vocational Rehabilitation).</li>
                </ul>
            </>,
            <>
                <b>Your Rights as a 1915(i) RISE Participant</b><br />
                You have the right to:<br />
                <ul>
                    <li>Be treated with dignity and respect.</li>
                    <li>Choose your services and providers.</li>
                    <li>Receive services in the community.</li>
                    <li>File complaints or appeals.</li>
                    <li>Be involved in decisions that affect your care.</li>
                </ul>
            </>
        ]
    },
    {
        format: bodyHelperTypes.title,
        order: 20,
        content: "1915(i) RISE Initiative – How to Apply "
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 30,
        content: [
            <>
                <b>A Step-by-Step Guide to Getting Services</b><br />
                If you or someone you support is struggling with serious mental illness (SMI) and needs support to live safely and independently in the community, the <b>1915(i) RISE Initiative</b> may be right for you. The application and enrollment process is <b>free, confidential,</b> and <b>centered on your choices and goals.</b>
            </>,
            <>
                <b>Step 1: Learn About the Program</b><br />
                The 1915(i) RISE Initiative provides Medicaid-funded services like case management, housing supports, supported employment and education, daily living assistance, and more. You can get started by talking with your current providers who might be:<br />
                <ul>
                    <li>A behavioral health provider.</li>
                    <li>A Community Mental Health Center (CMHC).</li>
                    <li>A hospital discharge planner.</li>
                    <li>A case manager or jail reentry coordinator</li>
                    <li>Or by self-referring.</li>
                </ul>
            </>,
            <>
                <b>Step 2: Make a Referral</b><br />
                Referrals can be made by:
                <ul>
                    <li>You (self-referral).</li>
                    <li>Family or caregiver.</li>
                    <li>Case managers or providers.</li>
                    <li>Shelters, jails, or hospitals.</li>
                </ul>
            </>,
            <>
                Ask to be connected to a certified 1915(i) RISE Initiative Specialist. You may also contact:<br />
                <ul>
                    <li>502-564-9189</li>
                    <li><b>Email:</b><a href="mailto:1915iRISEInitiative@ky.gov ">1915iRISEInitiative@ky.gov </a></li>
                </ul>
            </>,
            <>
                <b>Step 3: 1915(i) RISE Eligibility Screening</b><br />
                An agent will contact you within three business days to: <br />
                <ul>
                    <li>Conduct <b>pre-screening.</b></li>
                    <li>Explain the program and your rights.</li>
                    <li>Begin gathering the information needed to determine eligibility.</li>
                </ul>
            </>,
            <>
                <b>Step 4: interRAI Community Mental Health (CMH) Assessment</b><br />
                A certified assessor will complete an assessment to understand:
                <ul>
                    <li>Your behavioral health history.</li>
                    <li>Any challenges with housing, employment, or daily living. </li>
                    <li>Your support needs and services that are relevant to you.</li>
                </ul>
                This assessment helps determine your functional eligibility for services.
            </>,
            <>
                <b>Step 5: Person-Centered Service Plan (PCSP)</b><br />
                If you’re eligible, you will select a <b>case manager</b> who will help you develop a <b>PCSP</b>, which outlines:
                <ul>
                    <li>The services you’ll receive.</li>
                    <li>Your personal goals and preferences.</li>
                    <li>The providers you’ve selected.</li>
                </ul>
                This plan can be updated at any time to reflect your changing needs.
            </>,
            <>
                <b>Step 6: Start Services</b><br/>
                Once your plan is approved:
                <ul>
                    <li>Your service providers will contact you to begin.</li>
                    <li>You will have regular check-ins with your case manager.</li>
                    <li>You can change services or providers if needed.</li>
                </ul>
            </>,
            <>
                <b>Need Help Navigating the Process?</b><br/>
                We’re here to help:
                <ul>
                    <li><b>Call:</b> 502-564-9189</li>
                    <li><b>Email:</b> <a href="mailto:1915iRISEInitiative@ky.gov">1915iRISEInitiative@ky.gov</a></li>
                    <li><b>Visit:</b> <a href="https://dbhdid.ky.gov/1915iriseinitiative">https://dbhdid.ky.gov/1915iriseinitiative</a> to find a provider near you.</li>
                </ul>
            </>
        ]
    }



];

export default LittleEyeParticipant_Content;